import React from 'react';
import {useTranslation} from 'react-i18next';
import {IV_DOCUMENT_IMAGE_TYPES, STATUSES} from '@chekin/core';
import {StatusModalStates} from '../StatusModal';
import {ModalProps} from '@guestapp/old-ui-kit';
import passportGif from '../../assets/images/passport.gif?no-inline';
import selfieGif from '../../assets/images/selfie.gif?no-inline';
import {FailedModal} from './FailedModal';
import {StyledModal} from './styled';

const IconProps = {width: 50, height: 50};

const StatusesDTO: {[key in STATUSES]: StatusModalStates} = {
  [STATUSES.success]: StatusModalStates.SUCCESS,
  [STATUSES.loading]: StatusModalStates.LOADING,
  [STATUSES.idle]: StatusModalStates.IDLE,
  [STATUSES.error]: StatusModalStates.IDLE,
};

type IVProgressModalProps = ModalProps & {
  state: STATUSES;
  onTryAgain: () => void;
  layoutMode: string;
  isRequired: boolean;
  onVerifyLater: () => void;
  reasons?: string[];
  errorMessage?: string;
  failedImage?: string;
  docType?: IV_DOCUMENT_IMAGE_TYPES;
};
function IVProcessModal({
  open,
  state,
  reasons,
  errorMessage,
  failedImage,
  onTryAgain,
  onVerifyLater,
  onClose,
  docType,
  isRequired,
  layoutMode,
}: IVProgressModalProps) {
  const {t} = useTranslation();

  const failedModalImage =
    docType === IV_DOCUMENT_IMAGE_TYPES.selfie ? selfieGif : passportGif;

  const getTitle = () => {
    switch (state) {
      case STATUSES.success:
        return docType === IV_DOCUMENT_IMAGE_TYPES.selfie
          ? t('identity_verified_exclamation')
          : t('document_scanned_exclamation');
      default:
        return docType === IV_DOCUMENT_IMAGE_TYPES.selfie
          ? `${t('verification_in_progress')}`
          : `${t('scanning')}...`;
    }
  };

  const getDescription = () => {
    switch (state) {
      case STATUSES.loading:
        return t('this_could_take_a_couple_of_seconds');
      default:
        return '';
    }
  };

  if (state === STATUSES.error) {
    return (
      <FailedModal
        open={open}
        reasons={reasons}
        title={errorMessage}
        onTryAgain={onTryAgain}
        onClose={onClose}
        image={failedModalImage}
        failedImage={failedImage}
        onVerifyLater={onVerifyLater}
        docType={docType || IV_DOCUMENT_IMAGE_TYPES.back}
        layoutMode={layoutMode}
        isRequired={isRequired}
      />
    );
  }

  return (
    <StyledModal
      open={open}
      title={getTitle()}
      text={getDescription()}
      state={StatusesDTO[state]}
      iconProps={IconProps}
    />
  );
}

export {IVProcessModal};
